import { useEffect } from 'react';

const useCardTilt = () => {
    useEffect(() => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) return undefined;

        let active = null;

        const tilt = (card, event) => {
            const bounds = card.getBoundingClientRect();
            const x = (event.clientX - bounds.left) / bounds.width - 0.5;
            const y = (event.clientY - bounds.top) / bounds.height - 0.5;
            card.style.transform = `perspective(900px) rotateX(${(-y * 7).toFixed(2)}deg) rotateY(${(x * 9).toFixed(2)}deg) translateY(-6px)`;
        };

        const onMove = (event) => {
            const card = event.target.closest?.('.tilt-3d');
            if (active && active !== card) active.style.transform = '';
            active = card;
            if (card) tilt(card, event);
        };

        const onLeave = () => {
            if (active) active.style.transform = '';
            active = null;
        };

        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerleave', onLeave);
        return () => {
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerleave', onLeave);
            if (active) active.style.transform = '';
        };
    }, []);
};

export default useCardTilt;
